<template>
    <transition name="slide-fade" mode="out-in">
    	<div class="contain">
    		<div class="mC-top-bg flex-row1 color-fff padding-lr-24">
    			<img class="width-64 border-rad" :src="portrait">
    			<div class="width-156 padding-lr-16 margin-t-24">
					<div class="mC-name-bg float-l flex-row1">
						<div class="change-point">{{memberInfo.account}}</div>
						<img v-show="memberInfo.gender=='m'" class="width-12" src="../../../images/icon/man.png">
                        <img v-show="memberInfo.gender=='f'" class="width-12" src="../../../images/icon/woman.png">
					</div>
    				<div class="float-l margin-t-8 width-136">有效期至&nbsp;{{memberInfo.interestEndDate}}</div>
    				<div class="margin-t-8 float-l">
    					<img class="width-36" :class="[memberInfo.vipType?'':'opacity-3']" src="../../../images/common/equity-account.png">
    					<img class="width-36 margin-l-8" :class="[lockInfo.hasLockInterest?'':'opacity-3']" src="../../../images/common/equity-lock.png">
    				</div>
    			</div>
    			<div class="flex-row2" @click="goOnLineService()">
    				在线客服<span class="opacity-0">.</span>
    				<img class="width-12" src="../../../images/icon/arrow-white-r.png">
    			</div>
    		</div>
    		<div class="padding-lr-24 flex-row2 height-56">
    			<div class="flex-row1 size-16">
	    			<img v-show="memberInfo.curLevelId==1" class="width-36" src="../../../images/common/mC-V1.png">
                    <img v-show="memberInfo.curLevelId==2" class="width-36" src="../../../images/common/mC-V2.png">
                    <img v-show="memberInfo.curLevelId==3" class="width-36" src="../../../images/common/mC-V3.png">
                    <img v-show="memberInfo.curLevelId==4" class="width-36" src="../../../images/common/mC-V4.png">
                    <img v-show="memberInfo.curLevelId==5" class="width-36" src="../../../images/common/mC-V5.png">
	    			<span class="opacity-0">.</span>我的企业等级特权
	    		</div>
    			<div class="color-blue" @click="goMemberPower()">查看全部</div>
    		</div>
    		<div class="mC-img-box">
                <div class="mC-power-img" :class="item.className" v-for="(item,index) in privilegeList" :key="index" @click="goGiftDetail(index)">
                    <div :class="{'opacity-0':index>3}">{{item.privilegeName}}</div>
                </div>
		    </div>
            <!-- 会员成长体系 去掉 -->
            <!-- <div class="cut-line-8"></div>
		    <div class="padding-lr-24 flex-row2 height-56">
    			<div class="size-16">会员成长</div>
    			<div class="color-blue" @click="goMemberGrowthRule()">规则介绍</div>
    		</div>
    		<div class="padding-lr-24 flex-row2 height-72">
    			<div>
	    			<div class="size-16">会员等级</div>
	    			<div class="color-999 change-point width-256">距离{{memberInfo.nextLevelName}}会员还差{{memberInfo.upgradeScore}}成长值</div>
	    		</div>
    			<div class="flex-row1 color-999" @click="goMemberGrade()">
    				详情<span class="opacity-0">.</span>
    				<img class="width-12 margin-b--2" src="../../../images/icon/arrow-gray-r.png">
    			</div>
    		</div>
    		<progress-bar v-if="showBar" :items="growthValueBar"></progress-bar>
    		<div class="padding-lr-24 flex-row2 height-72">
    			<div>
	    			<div class="size-16">会员任务</div>
	    			<div class="color-999 change-point width-256">8项任务未完成，完成后可得600成完成后可得600成完成后可得600成</div>
	    		</div>
    			<div class="flex-row1 color-999" @click="goMemberTask()">
    				去完成<span class="opacity-0">.</span>
    				<img class="width-12 margin-b--2" src="../../../images/icon/arrow-gray-r.png">
    			</div>
    		</div>
            <progress-bar :items="growthValueBar1"></progress-bar>
    		<div class="padding-lr-24 flex-row2 height-72">
    			<div>
	    			<div class="size-16">会员商城</div>
	    			<div class="color-999 change-point width-256">暂未开启，敬请期待！</div>
	    		</div>
    			<div class="flex-row1 color-999 opacity-3">
    				详情<span class="opacity-0">.</span>
    				<img class="width-12 margin-b--2" src="../../../images/icon/arrow-gray-r.png">
    			</div>
    		</div> -->
            <!-- 会员日入口 暂时 去掉 -->
    		<!--<div class="cut-line-8"></div> 
    		<div class="padding-lr-24 flex-row2 height-72">
    			<div>
	    			<div class="size-16">广材会员日</div>
	    			<div class="color-999 change-point">第一期会员日活动正在进行中...</div>
	    		</div>
    			<div class="color-blue" @click="goMemberDay()">活动详情</div>
    		</div>
    		<div class="text-c border-rad-4 padding-b-24" @click="goMemberDay()">
    			<img class="width-326" src="../../../images/member/ad-3.png">
    		</div>
            -->
    	</div>
    </transition>
</template>

<style lang="less" scoped>
@import "../../../style/variable.less";
@import "./style.less";
</style>

<script>
module.exports = require("./index.js")
</script>